module.exports = __webpack_public_path__ + "files/93782d6ae081c3974ac29e878ee98266.png";